import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import api from "APP_ROOT/api";
import { Col } from "react-bootstrap";
import isFunction from "lodash/isFunction";

import { Select } from "MODULES/shared/components/Forms";
import { fobFormat } from "LIB/formatters/address";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { PHYSICAL_ADDRESS } from "MODULES/companies/constants";
import { AddressFields } from "MODULES/companies/components/AddressFields";
import {
  CITY,
  COUNTRY,
  LINE1,
  POSTAL_CODE,
  SHIP_TO_CUSTOMER_ADDRESS_ID,
  STATE
} from "APP_ROOT/constants";
import { OTHER } from "MODULES/shared/constants";
import RestrictedAddressWarning from "MODULES/shared/components/RestictedAddressWarning/RestrictedAddressWarning";

const addressLine = ({ line1, line2, city, state, ...address }) => {
  const parts = [line1, line2, city, state].filter(p => p);

  return `${parts.join(", ")} ${address.postal_code}`;
};

const NewAddress = ({ copyBillingAddress, getField, setFieldValue }) => {
  const addressFields = [LINE1, CITY, STATE, POSTAL_CODE, COUNTRY].reduce(
    (final, f) => ({
      ...final,
      [f]: getField(`${PHYSICAL_ADDRESS}.${f}`)
    }),
    {}
  );
  return [
    <FormRow>
      <Col md={12}>
        <button
          className="btn btn-success btn-sm btn-hollow"
          onClick={ev => {
            ev.preventDefault();
            copyBillingAddress();
          }}
        >
          Same As Billing Address
        </button>
      </Col>
    </FormRow>,
    <br />,
    <AddressFields
      path={PHYSICAL_ADDRESS}
      setFieldValue={setFieldValue}
      country={getField([PHYSICAL_ADDRESS, COUNTRY].join("."))}
      showRegion
    />,
    <RestrictedAddressWarning {...addressFields} />
  ];
};

NewAddress.propTypes = {
  copyBillingAddress: T.func,
  getField: T.func,
  setFieldValue: T.func
};

export class ShipToCustomerAddress extends React.Component {
  state = {
    addresses: []
  };

  componentWillMount() {
    const { company } = this.props;

    if (company && company.id) {
      this.fetchAddresses(company.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.company && !this.props.company) ||
      (nextProps.company &&
        nextProps.company.id &&
        nextProps.company.id !== this.props.company.id)
    ) {
      this.onChangeAddress(null);

      this.fetchAddresses(nextProps.company.id);
    } else if (!nextProps.company) {
      this.setState({ addresses: [] });
    }
  }

  onChangeAddress = address => {
    const { onChangeAddress } = this.props;

    if (isFunction(onChangeAddress)) {
      onChangeAddress(address);
    }
  };

  setCustomerAddressForRestrictedCheck = id => {
    const address = this.state.addresses.find(a => Number(a.id) === Number(id));
    if (address) {
      this.setState({ selectedAddress: address });
    } else {
      this.setState({ selectedAddress: {} });
    }
  };

  fetchAddresses = companyId => {
    const { setFOB, ship_to_customer_address_id } = this.props;

    api.companies.physicalAddresses
      .search(companyId, {
        page: 1,
        limit: 100
      })
      .then(resp => {
        this.setState({ addresses: resp.data.results }, () => {
          if (resp.data.results.length > 0) {
            const primaryAddress = resp.data.results.find(a => a.primary);
            if (!ship_to_customer_address_id.input.value) {
              // set to default address if not set
              ship_to_customer_address_id.input.onChange(primaryAddress.id);
              this.setCustomerAddressForRestrictedCheck(primaryAddress.id);
            }

            this.onChangeAddress(primaryAddress);

            return setFOB && setFOB(fobFormat(primaryAddress));
          }

          this.onChangeAddress(null);

          return ship_to_customer_address_id.input.onChange(null);
        });
      });
  };

  render() {
    const { addresses, selectedAddress } = this.state;
    const { copyBillingAddress, getField, setFieldValue } = this.props;

    if (addresses.length === 0 && copyBillingAddress) {
      return (
        <NewAddress
          copyBillingAddress={copyBillingAddress}
          setFieldValue={setFieldValue}
          getField={getField}
        />
      );
    }

    const options = addresses.map(a => ({
      text: addressLine(a),
      value: a.id
    }));

    if (copyBillingAddress && options.length > 0) {
      options.push({
        text: "+ Add An Address",
        value: "other"
      });
    }

    return (
      <React.Fragment>
        <FormRow>
          <Col md={8}>
            <Field
              name={SHIP_TO_CUSTOMER_ADDRESS_ID}
              component={Select}
              label="Customer Address"
              required
              options={options}
              prompt={false}
              onChange={(ev, val) =>
                this.setCustomerAddressForRestrictedCheck(val)}
            />
          </Col>
        </FormRow>
        {getField &&
          getField(SHIP_TO_CUSTOMER_ADDRESS_ID) === OTHER && (
            <NewAddress
              getField={getField}
              copyBillingAddress={copyBillingAddress}
              setFieldValue={setFieldValue}
            />
          )}
        <FormRow>
          <Col md={12}>
            {selectedAddress && (
              <RestrictedAddressWarning {...selectedAddress} />
            )}
          </Col>
        </FormRow>
      </React.Fragment>
    );
  }
}

ShipToCustomerAddress.propTypes = {
  company: T.shape({ id: T.number }),
  copyBillingAddress: T.func,
  getField: T.func,
  setFieldValue: T.func,
  setFOB: T.func,
  onChangeAddress: T.func,
  ship_to_customer_address_id: F.formField(F.malleable).isRequired
};

ShipToCustomerAddress.defaultProps = {
  onChangeAddress: () => null
};

export default withFormFields(ShipToCustomerAddress, [
  SHIP_TO_CUSTOMER_ADDRESS_ID
]);



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/ShipToCustomerAddress.jsx